export default "__VITE_ASSET__BKNkipR3__"